import { Observable, of as observableOf } from 'rxjs';

import { catchError, map, take } from 'rxjs/operators';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { ActivationEventService } from '../activation-event.service';
import { Injectable } from '@angular/core';

@Injectable()
export class AccountDetailsGuard {
  accountID: string;

  constructor(
    private router: Router,
    private activationEventService: ActivationEventService,
    private snackbarService: SnackbarService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (this.accountID === route.params.accountId) {
      return observableOf(true);
    }
    this.accountID = route.params.accountId;
    let path = route.routeConfig.path.split('/')[1];
    const appId = state.url.split('/')[2];
    return this.activationEventService.isAccountActive$(appId, this.accountID).pipe(
      map((isActive) => {
        if (isActive && path === 'deactivated-details') {
          path = 'details';
          this.router.navigate([`apps/${appId}/accounts/${this.accountID}/${path}`]);
        } else if (!isActive && path === 'details') {
          path = 'deactivated-details';
          this.router.navigate([`apps/${appId}/accounts/${this.accountID}/${path}`]);
        }
        return true;
      }),
      catchError((err) => {
        this.accountID = '';
        console.error(err);
        this.snackbarService.openErrorSnack('Failed to get the account');
        this.router.navigate([`apps/${appId}/accounts`]);
        return observableOf(true);
      }),
      take(1),
    );
  }
}
